var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCocktail = function SvgCocktail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4h17L13 12.4V19h3.3a1 1 0 1 1 0 2H7.7a1 1 0 1 1 0-2H11v-6.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 2.2a1 1 0 0 1 1.5 1.3l-3.9 4.4-1.5-1.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8,
    cy: 2.6,
    r: 1.5
  })));
};
export default SvgCocktail;